jQuery(function($) {
    var enable = 1
    $('.navigation').data('sticky-nav', enable);
    Bunyad_Theme.sticky_nav();
    
});
